import { Box } from 'braid-design-system';

import Logo from './Logo/Logo';

import * as styles from './Header.css';

const Header = () => (
  <Box
    className={styles.header}
    background="surface"
    data={{ testid: 'header' }}
  >
    <Logo />
  </Box>
);

export default Header;
